module.exports = __webpack_public_path__ + "img/9.7ff70b3d.png";